import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {SharedModule} from "../../shared/shared.module";
import {ReactiveFormsModule} from "@angular/forms";
import {
  ReportsScreenComponent
} from './screens/reports-screen/reports-screen.component';
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/reports.reducer";
import {EffectsModule} from "@ngrx/effects";
import {ReportsEffects} from "./core/reports.effects";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatTableModule} from "@angular/material/table";
import {MatExpansionModule} from "@angular/material/expansion";
import {NgxTippyModule} from "ngx-tippy-wrapper";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { MaterialModule } from "../../shared/material-module";

@NgModule({
  declarations: [
    ReportsScreenComponent
  ],
  imports: [
    CommonModule, 
    MaterialModule,
    SharedModule, 
    ReactiveFormsModule,
    StoreModule.forFeature("ss-cord.reports", reducer),
    EffectsModule.forFeature(
      [ReportsEffects]
    ), 
    NgxTippyModule,
    InfiniteScrollModule
  ]
})
export class ReportsModule {}
